'use strict';

angular.module('internal.setup')
    .controller('InternalSetupIntegrations', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
    }])
;